import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { AlarmType } from '@/types/types'
import useI18nTl from '@/hooks/useI18nTl'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'AlarmType',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  state: {
    type: Number,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Evses')



const statusLabel = computed(() => {
  switch (props.state) {
    case AlarmType.AT_INTERVAL:
      return tl('alarmTypeInterval')
    case AlarmType.AT_BURST:
      return tl('alarmTypeBurst')
    case AlarmType.AT_GRADUAL:
      return tl('alarmTypeGradual')
    case AlarmType.AT_COMPONENT:
      return tl('alarmTypeComponent')
  }
  return t('Base.Unknown')
})

const color = computed(() => {
  return '#5e4eff'
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "text-status",
    style: _normalizeStyle({ color: _unref(color) })
  }, _toDisplayString(_unref(statusLabel)), 5))
}
}

})